import { Link } from 'react-router-dom'
import { FileX, Users } from 'lucide-react'

const ListasPage = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Listas</h1>
        <p className="mt-2 text-gray-600">Gerencie listas de bloqueios e participantes anteriores</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Card Lista Negativa */}
        <Link
          to="/admin/lista-negativa"
          className="card hover:shadow-lg transition-shadow cursor-pointer group"
        >
          <div className="flex flex-col items-center text-center p-8">
            <div className="mb-4">
              <FileX className="h-16 w-16 text-blue-600 group-hover:text-blue-700 transition-colors" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              Gerenciamento de Lista Negativa
            </h2>
            <p className="text-gray-600 mb-6">
              Acesse a página completa para gerenciar registros bloqueados
            </p>
            <button className="btn btn-primary flex items-center gap-2">
              <FileX className="h-4 w-4" />
              Ir para Lista Negativa
            </button>
          </div>
        </Link>

        {/* Card Participantes Anteriores */}
        <Link
          to="/admin/participantes-anteriores"
          className="card hover:shadow-lg transition-shadow cursor-pointer group"
        >
          <div className="flex flex-col items-center text-center p-8">
            <div className="mb-4">
              <Users className="h-16 w-16 text-green-600 group-hover:text-green-700 transition-colors" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              Gerenciamento de Participantes Anteriores
            </h2>
            <p className="text-gray-600 mb-6">
              Acesse a página completa para gerenciar participantes de edições anteriores
            </p>
            <button className="btn btn-primary flex items-center gap-2">
              <Users className="h-4 w-4" />
              Ir para Participantes Anteriores
            </button>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default ListasPage

